import Vue from 'vue';
export default class SearchStatsHeaderSkeleton extends Vue {
}
